import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createHead } from '@vueuse/head';

const app = createApp(App);

app.use(store);
app.use(createHead());
app.use(router);
app.mount('#app');
